import { Button } from "@carbon/react";

export const View = ({ children, className = "", ...rest }) => {
  return (
    <Button className={`switchapp-themed ${className}`} {...rest}>
      {children}
    </Button>
  );
};
